/// <reference types="vite/client" />
import React from "react";
import { createRoot } from "react-dom/client";
import "@/app/globals.css";
import "./spa.css";
import { ProgressNoteApp } from "@/app/components/ProgressNoteApp";
import { AuthGate } from "@/app/components/AuthPanel";
import { LanguageProvider } from "@/src/i18n";

// Resolve the agent endpoint at startup: runtime /config.js wins, then the
// build-time env var. Left empty -> the client falls back to safe simulation.
const runtimeEndpoint =
  typeof window !== "undefined" ? window.__SATI_CONFIG__?.agentEndpoint : undefined;
const envEndpoint = import.meta.env.VITE_SATI_AGENT_ENDPOINT as string | undefined;
globalThis.__SATI_AGENT_ENDPOINT__ = runtimeEndpoint || envEndpoint || undefined;

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found");

createRoot(container).render(
  <React.StrictMode>
    <LanguageProvider>
      <AuthGate>
        <ProgressNoteApp />
      </AuthGate>
    </LanguageProvider>
  </React.StrictMode>,
);
